<template>
    <div class="columns is-multiline">
        <div class="column is-3" v-for="item in feed" :key="item.id" :class="itemClass(item)" @click="toggle(item)">
            <div :id="`item-${item.id}`"></div>
        </div>
    </div>
</template>
<script>
    import FeedMixin from './FeedMixin';
    export default {
        name: 'PinterestFeed',
        mixins: [FeedMixin],
        mounted() {
            this.$nextTick(() => {
                for(let i in this.items) {
                    embedo.load(
                        document.getElementById(`item-${this.items[i].id}`),
                        this.items[i].link,
                        {
                            strict: false
                        }
                    )
                }
            });
        }
    }
</script>